import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "ub_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) clearToken();
    return Promise.reject(err);
  }
);

export const login = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  setToken(data.token);
  return data;
};

export const me = () => api.get("/auth/me").then((r) => r.data);

export const listItems = (resource) =>
  api.get(`/content/${resource}`).then((r) => r.data);

export const createItem = (resource, payload) =>
  api.post(`/content/${resource}`, payload).then((r) => r.data);

export const updateItem = (resource, id, payload) =>
  api.put(`/content/${resource}/${id}`, payload).then((r) => r.data);

export const deleteItem = (resource, id) =>
  api.delete(`/content/${resource}/${id}`).then((r) => r.data);

/* Public getter — no auth required. Used by the CV site itself. */
export const publicList = (resource) =>
  axios.get(`${BASE}/api/content/${resource}`).then((r) => r.data);

/* Upload a file (image or PDF). Returns { id, url, path, filename, content_type, size } */
export const uploadFile = (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return api
    .post("/files/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    })
    .then((r) => r.data);
};

/* Bulk upsert items — used by "Import site defaults" */
export const bulkUpsert = (resource, items) =>
  api.post(`/content/${resource}/bulk-upsert`, { items }).then((r) => r.data);

/* Convert a stored file URL to an absolute URL usable in <img src="..."> */
export const fileUrl = (relativeOrAbsolute) => {
  if (!relativeOrAbsolute) return "";
  if (/^https?:\/\//i.test(relativeOrAbsolute)) return relativeOrAbsolute;
  return `${BASE}${relativeOrAbsolute}`;
};

export default api;
